import { Stack, styled } from "@mui/material";
import Button from "@mui/material/Button";

export const ButtonWithIconRightRoot = styled(Button)(({ theme }) => ({
    fullWidth: true,
    disableElevation: true,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    width: "100%",
    textTransform: "none",
    padding: "12px 15px",
    borderRadius: 4,
    color: theme.palette.primary.contrastText,
    background: `linear-gradient(90deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main}  100%)`,
    boxShadow: "none",
    "& .MuiButton-endIcon": {
        marginLeft: theme.spacing(4),
        marginRight: 0,
    },
    "&.Mui-disabled": {
        display: "none",
    },
}));

export const ButtonContent = styled(Stack)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
}));

export const ButtonTitle = styled(Stack)(({ theme }) => ({
    fontSize: "1.6rem",
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1.2,
}));

export const ButtonSubtitle = styled(Stack)(({ theme }) => ({
    fontSize: "1.4rem",
    fontWeight: theme.typography.fontWeightLight,
    lineHeight: 1.2,
    opacity: 0.95,
}));

export const RightIconWrapper = styled(Stack)(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.contrastText,
    marginLeft: theme.spacing(2),
    "& .MuiSvgIcon-root": {
        fontSize: 24,
    },
}));
